import { Component, OnInit } from '@angular/core';
import {AppState} from "../../../app.service";
import { smoothlyMenu } from '../../../app.helpers';
declare var jQuery:any;

@Component({
  selector: 'topnavigationnavbar',
  template: require('./topnavigationnavbar.template.html')
})
export class TopNavigationNavbarComponent {

  isAuthenticated:boolean;
  profileImage: string;
  constructor(private appState: AppState) {}

  ngOnInit() {
    this.isAuthenticated = this.appState.isLoggedIn();
    this.profileImage = this.appState.getCookie("imageUrl");
  }

  toggleNavigation(): void {
    jQuery("body").toggleClass("mini-navbar");
    smoothlyMenu();
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/components/common/navigation/topnavigationnavbar.component.ts